module.exports = __webpack_public_path__ + "static/img/ewm2.57aff59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm2.png
// module id = cfuH
// module chunks = 1